import { InfoCardErrorView } from "./InfoCardErrorView";
export default InfoCardErrorView;
